// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "container-Vb25i";
var _3 = "switch__wrapper-16cQ0";
var _4 = "switch__icon-1_XMO";
var _5 = "switch__root-1LpG6";
var _6 = "switch__label-2o1NQ";
var _7 = "description-1ZMnX";
var _8 = "switch__infoIcon-1lywZ";
export { _1 as "__esModule", _2 as "container", _3 as "switch__wrapper", _4 as "switch__icon", _5 as "switch__root", _6 as "switch__label", _7 as "description", _8 as "switch__infoIcon" }
export default { "__esModule": _1, "container": _2, "switch__wrapper": _3, "switch__icon": _4, "switch__root": _5, "switch__label": _6, "description": _7, "switch__infoIcon": _8 }
